(function ($) {
  Drupal.behaviors.phoneNumber = {
    attach: function (context, settings) {
      let inputPhoneNumer = document.querySelector(
        ".data-update-form .js-form-item-cellphone-number input"
      );
      if (inputPhoneNumer != null) {
        inputPhoneNumer.setAttribute("minlength", 10);
        inputPhoneNumer.setAttribute("maxlength", 10);
      }
      let formValidation = document.querySelectorAll(".js-form-item-validation");
      let step2Continuar = document.querySelector(
        ".step-2.btn-continuar .js-form-submit"
      );
      let updateTextStep2 = document.querySelector(".update.text.step-2");

      if (step2Continuar !== null) {
        let btnConttinuarParent = step2Continuar.parentElement;
        btnConttinuarParent.append(updateTextStep2);
        //error if no checked option
        step2Continuar.addEventListener("mousedown", () => {
          step2Continuar
            .closest("form.data-update-form")
            .classList.add("error-med");
          if (formValidation[0].classList.contains("js-checked") || formValidation[1].classList.contains("js-checked")) {
            step2Continuar
              .closest("form.data-update-form")
              .classList.remove("error-med");
          } 
        });

        //remove error if option checked
        let labelOption = document.querySelectorAll(
          ".js-form-item-validation label.option"
        );
        labelOption.forEach((option) => {
          option.addEventListener("click", () => {
            step2Continuar
              .closest("form.data-update-form")
              .classList.remove("error-med");
          });
        });
      }
    },
  };
})(jQuery);
